module.exports = __webpack_public_path__ + "static/media/logo.ebf1d557.svg";